// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@/views/error-page/ieTips.js";

Array.prototype.inArray = function(key) {
    let ok = false
    this.forEach(v => {
        if (v == key) {
            ok = true
        }
    });
    return ok
}

import Vue from 'vue'
import App from './App'
//引入全局公共样式
import "@/assets/css/global.scss";
import ElementUI from 'element-ui';
//引入element-ui样式
import 'element-ui/lib/theme-chalk/index.css';
//引入font图标库依赖样式
import '@/assets/lib/font-awesome/4.7.0/css/font-awesome.min.css';
//引入js-cookie组件
import Cookies from 'js-cookie';

//引入通用函数库
const require_module = require.context('./function', false, /\.js|\.vue$/)
require_module.keys().forEach(file_name => {
    let functions = require_module(file_name).default
        //合并函数对象到vue
    Vue.prototype = Object.assign(Vue.prototype, functions)
        //console.log('Vue.prototype', Vue.prototype)
})

import VueRouter from 'vue-router';

import api from './api';

//引入路由配置
import router from './router';
//引入助手方法
import tool from './utils/tool';
//引入系统配置
import config from './config';
//引入layer
import layer from 'vue-layer';
import 'vue-layer/lib/vue-layer.css';
Vue.prototype.$config = config

Vue.prototype.$TOOL = tool

Vue.prototype.$cookies = Cookies

Vue.prototype.$api = api

Vue.prototype.$layer = layer(Vue);

Vue.prototype.getTime = function() {
    return parseInt((new Date()).getTime() / 1000);
}

ElementUI.Dialog.props.lockScroll.default = false
Vue.use(VueRouter)
Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
    //locale: enLang // 如果使用中文，无需设置，请删除
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js